import css from 'styled-jsx/css';

const styles = css.global`.sn-button {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;

  border-radius: 4px;
  padding: 8px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;

  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.sn-button.centered,
.sn-button-flat.centered {
  margin-left: auto;
  margin-right: auto;
}

.sn-button.red {
  color: #fff;
  background: #cc0000;
}

.sn-button.white {
  color: #cc0000;
  background: #fff;
  border: 1px solid #cc0000;
}

.sn-button[disabled],
.sn-button.loading {
  opacity: 0.5;
  cursor: not-allowed;
}

.sn-button.loading {
  cursor: progress;
}

.sn-button.red[disabled],
.sn-button.red.loading {
  opacity: 1;
  background-color: #ccc;
}

.sn-button-flat,
.sn-button.flat-red {
  background: none;
  outline: none;
  border: none;
  cursor: pointer;
}

.sn-button-flat > img {
  pointer-events: none;
}

.sn-button.flat-red {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 48px;
  text-align: center;
  color: #cc0000;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
}
`;

export default styles;